var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoftwares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "767.000000pt",
    height: "702.000000pt",
    viewBox: "0 0 767.000000 702.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,702.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M615 7003 c-270 -57 -483 -252 -572 -521 l-28 -87 0 -2885 0 -2885 28 -87 c80 -242 263 -425 505 -505 l87 -28 3175 0 c2439 0 3195 3 3263 12 71 10 105 21 179 60 205 106 325 245 390 453 l23 75 3 2405 2 2405 -31 96 c-42 132 -106 237 -199 329 -90 89 -188 147 -317 189 l-93 30 -1822 7 -1823 6 -57 30 c-74 39 -301 228 -766 640 -79 70 -169 144 -200 164 -78 52 -177 92 -258 104 -41 6 -346 9 -744 9 -560 -1 -687 -3 -745 -16z m1541 -325 c53 -28 202 -154 597 -503 131 -115 259 -227 285 -247 60 -48 183 -113 274 -144 l72 -24 1828 0 c1005 0 1828 -4 1828 -8 0 -4 28 -21 62 -37 90 -43 168 -119 217 -214 l41 -80 -2 -2408 -3 -2408 -28 -57 c-41 -84 -100 -142 -196 -193 l-84 -45 -3200 0 -3199 0 -79 41 c-96 50 -170 126 -216 222 l-33 67 0 2870 0 2870 36 72 c20 39 58 95 85 123 49 52 145 112 204 126 16 4 352 7 745 6 l715 -2 51 -27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 4150 l0 -800 800 0 800 0 0 800 0 800 -800 0 -800 0 0 -800z m1280 0 l0 -480 -480 0 -480 0 0 480 0 480 480 0 480 0 0 -480z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4640 4150 l0 -800 800 0 800 0 0 800 0 800 -800 0 -800 0 0 -800z m1280 0 l0 -480 -480 0 -480 0 0 480 0 480 480 0 480 0 0 -480z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1760 1910 l0 -800 800 0 800 0 0 800 0 800 -800 0 -800 0 0 -800z m1280 0 l0 -480 -480 0 -480 0 0 480 0 480 480 0 480 0 0 -480z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwares);
export default __webpack_public_path__ + "static/media/softwares.e846ad7372ac161b287ff263e35501c4.svg";
export { ForwardRef as ReactComponent };